

























import mixins from 'vue-typed-mixins'
import layoutMixin from '../layoutMixin'

export default mixins(layoutMixin).extend({
    data() {
        return {
            btnAffiche: false
        }
    },
    mounted() {
        setTimeout(this.timer, 10000)
    },
    methods: {
        timer() {
            this.btnAffiche = true
        },
        reload() {
            window.location.reload()
        }
    }
})
